export const ERROR = 'error';
export const ENTERUSERNAME = 'enter username';
export const VALID = 'validating';
export const SUCCESS = 'success';
export const USERAVAIL = 'Username available';
export const USEREXIST = 'Username already exist';
export const USERVALIDALPHA = "Username can be only 'a-z', 'A-Z', '_' '0-9'" ;
export const USERVALIDLEN="Too short username";
export const PASSLEN = 'Password should be more than 6 character';
export const PASSUPER = 'Password must have atleast 1 uppercase letter';
export const PASSLOWER = 'Password must have atleast 1 lowercase letter';
export const PASSDIGIT = 'Password must contain atleast 1 digit';
export const PASSSPEC =  'Password must have atleast 1 special character';
export const SUBSUCCESS= 'Submission sucessful';
export const SUBFAILED= 'submission failed';
export const CHECKUSERORMOB= 'Check username or Mobile Number';
export const INPUTUSERNAME= 'Please input your username!';
export const INPUTFIRSTNAME= 'Please input your First Name!';
export const INPUTFULLNAME= 'Please input your fullName!';
export const NOTVALIDEMAIL= 'Not  Valid  email!';
export const INPUTEMAIL= 'Please input your email!';
export const INPUTDOB= 'Please input your Date Of Birth!';
export const INPUTPHNO= 'Please input your phone number!';
export const INPUTPASS= 'Please input your password!';
export const INPUTCITY= 'Please input your City!';
export const INPUTCOMPANY= 'Please input your Company Name!';
export const REQUIRED_FIELD_MESSAGE = 'This field is required!'

export const ERROR_INTERNET_CONNECTIVITY = 'Connection Failed';
export const ERROR_MESSAGE_500 = 'Internal Server Error';
export const ERROR_MESSAGE_404 = 'Not Found';

/***
 * Status Constants
 * */

export const SUCCESS_MSG_TYPE = 'success';
export const WARNING_MSG_TYPE = 'warning';
export const ERROR_MSG_TYPE = 'error';
export const INFO_MSG_TYPE = 'info';
export const SUCCESS_MESSAGE = 'success';